const AuthTypes = {
  LOGIN_LOADING: "LOGIN_LOADING",
  LOGIN_ERROR: "LOGIN_ERROR",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",

  VERIFY_LOADING: "VERIFY_LOADING",
  VERIFY_ERROR: "VERIFY_ERROR",
  VERIFY_SUCCESS: "VERIFY_SUCCESS",

  GET_MEMBER_BY_EMAIL_LOADING: "GET_MEMBER_BY_EMAIL_LOADING",
  GET_MEMBER_BY_EMAIL_ERROR: "GET_MEMBER_BY_EMAIL_ERROR",
  GET_MEMBER_BY_EMAIL: "GET_MEMBER_BY_EMAIL",

  SIGNUP_LOADING: "SIGNUP_LOADING",
  SIGNUP_ERROR: "SIGNUP_ERROR",
  SIGNUP_SUCCESS: "SIGNUP_SUCCESS",

  LOGOUT: "LOGOUT",

  ADMIN_LOGIN_LOADING: "ADMIN_LOGIN_LOADING",
  ADMIN_LOGIN_ERROR: "ADMIN_LOGIN_ERROR",
  ADMIN_LOGIN_SUCCESS: "ADMIN_LOGIN_SUCCESS",

  LOGOUT_ADMIN: "LOGOUT_ADMIN",

  ADMIN_VERIFY_LOADING: "ADMIN_VERIFY_LOADING",
  ADMIN_VERIFY_ERROR: "ADMIN_VERIFY_ERROR",
  ADMIN_VERIFY_SUCCESS: "ADMIN_VERIFY_SUCCESS",

  FORGOT_PASSWORD_OTP_LOADING: "FORGOT_PASSWORD_OTP_LOADING",
  FORGOT_PASSWORD_OTP_ERROR: "FORGOT_PASSWORD_OTP_ERROR",
  FORGOT_PASSWORD_OTP_SUCCESS: "FORGOT_PASSWORD_OTP_SUCCESS",
  FORGOT_PASSWORD_OTP_CLEAR: "FORGOT_PASSWORD_OTP_CLEAR",

  RESET_PASSWORD_LOADING: "RESET_PASSWORD_LOADING",
  RESET_PASSWORD_ERROR: "RESET_PASSWORD_ERROR",
  RESET_PASSWORD_SUCCESS: "RESET_PASSWORD_SUCCESS",

  GET_MEMBER_BY_EMAIL_CLEAR: "GET_MEMBER_BY_EMAIL_CLEAR",

  GET_BUILDINGS_BY_ZIP_CODE_LOADING: "GET_BUILDINGS_BY_ZIP_CODE_LOADING",
  GET_BUILDINGS_BY_ZIP_CODE_ERROR: "GET_BUILDINGS_BY_ZIP_CODE_ERROR",
  GET_BUILDINGS_BY_ZIP_CODE_SUCCESS: "GET_BUILDINGS_BY_ZIP_CODE_SUCCESS",

  UPDATE_FIRST_LOGIN_PASSWORD_LOADING: "UPDATE_FIRST_LOGIN_PASSWORD_LOADING",
  UPDATE_FIRST_LOGIN_PASSWORD_ERROR: "UPDATE_FIRST_LOGIN_PASSWORD_ERROR",
  UPDATE_FIRST_LOGIN_PASSWORD_SUCCESS: "UPDATE_FIRST_LOGIN_PASSWORD_SUCCESS",

  SUBMIT_OTP_LOADING: "SUBMIT_OTP_LOADING",
  SUBMIT_OTP_ERROR: "SUBMIT_OTP_ERROR",
  SUBMIT_OTP_SUCCESS: "SUBMIT_OTP_SUCCESS",
  SUBMIT_OTP_SUCCESS_WITH_FIRST_LOGIN: "SUBMIT_OTP_SUCCESS_WITH_FIRST_LOGIN",

  CLEAR_NON_MEMBER_DATA: "CLEAR_NON_MEMBER_DATA",
};

export default AuthTypes;
